import { nieswiadomyUmyslChapters } from './content';
export const nieswiadomyUmyslQuickReference = nieswiadomyUmyslChapters.find((chapter) => chapter.title.toLocaleUpperCase('pl').includes('QUICK REFERENCE'));
